import { useCallback, useEffect } from "react";
import { refOptionsActions } from "../actions";
import { IRefOptionsContextService } from "../services";
import { RefOptionsDispatch } from "./useRefOptionsState";

export function useRefOptionsCodes(
  service: IRefOptionsContextService,
  dispatch: RefOptionsDispatch,
) {
  const fetchCodes = useCallback(async () => {
    dispatch(refOptionsActions.setLoadingCodes(true));

    try {
      const codes = await service.fetchCodes();
      dispatch(refOptionsActions.setCodes(codes));
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "Não foi possível carregar as opções do formulário. Atualize a página e tente novamente.";
      dispatch(refOptionsActions.setCodesError(errorMessage));
    }
  }, [service, dispatch]);

  const refreshCodes = useCallback(async () => {
    await fetchCodes();
  }, [fetchCodes]);

  useEffect(() => {
    fetchCodes();
  }, [fetchCodes]);

  return { refreshCodes };
}
